export const sv = {
  title: 'Jobb',
  subtitle: 'Hantera och följ upp bokningar',
  tabAll: 'Alla',
  tabUpcoming: 'Kommande',
  tabCompleted: 'Slutförda',
  tabCancelled: 'Avbokade',
  statusPendingPayment: 'Inväntar betalning',
  statusPending: 'Väntar',
  statusConfirmed: 'Bekräftad',
  statusCompleted: 'Slutförd',
  statusCancelled: 'Avbokad',
  statusPendingCancellation: 'Avbokning inväntar',
  defaultBookingTitle: 'Bokning',
  empty: 'Inga jobb hittades',
  colJob: 'Jobb',
  colCustomer: 'Kund',
  colVehicle: 'Fordon',
  colDate: 'Datum',
  colPrice: 'Pris',
  colStatus: 'Status',
  filterCustomerPlaceholder: 'Namn, telefon, e-post',
  filterVehiclePlaceholder: 'Reg.nr, märke, modell',
  clearFilters: 'Rensa filter',
}

export const en: typeof sv = {
  title: 'Jobs',
  subtitle: 'Manage and follow up on bookings',
  tabAll: 'All',
  tabUpcoming: 'Upcoming',
  tabCompleted: 'Completed',
  tabCancelled: 'Cancelled',
  statusPendingPayment: 'Awaiting payment',
  statusPending: 'Pending',
  statusConfirmed: 'Confirmed',
  statusCompleted: 'Completed',
  statusCancelled: 'Cancelled',
  statusPendingCancellation: 'Cancellation pending',
  defaultBookingTitle: 'Booking',
  empty: 'No jobs found',
  colJob: 'Job',
  colCustomer: 'Customer',
  colVehicle: 'Vehicle',
  colDate: 'Date',
  colPrice: 'Price',
  colStatus: 'Status',
  filterCustomerPlaceholder: 'Name, phone, email',
  filterVehiclePlaceholder: 'Reg no., make, model',
  clearFilters: 'Clear filters',
}
